import { Row, Col, Container, Button, Alert } from "reactstrap"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { MDBDataTable } from "mdbreact"
import CompanyModal from "./CompanyModal"
import General from "services/GeneralEndpoints"

const user = JSON.parse(localStorage.getItem("authUser"))
let generalService = new General(user)

const Companies = props => {
  const [companies, setcompanies] = useState()
  const [showModal, setshowModal] = useState(false)
  const [registrationSuccess, setregistrationSuccess] = useState()
  const [registrationError, setregistrationError] = useState()
  const [loading, setloading] = useState(false)

  useEffect(() => {
    fetchCompanies()
  }, [])

  const fetchCompanies = () => {
    let rows = []

    generalService.getCompanies().then(response => {
      console.log(response)
      response.data.forEach(item => {
        rows.push({
          name: item.name,
          tin: item.tin,
          telephone: item.telephone,
          email: item.email,
          actions: <button className="btn btn-primary"><i className="fas fa-edit" title="Edit"></i></button>
        })
      })
      const data = {
        columns: [
          {
            label: "Name",
            field: "name",
            sort: "asc",
            width: 150,
          },
          {
            label: "Tin",
            field: "tin",
            sort: "asc",
            width: 270,
          },
          {
            label: "Telephone",
            field: "telephone",
            sort: "asc",
            width: 200,
          },

          {
            label: "Email",
            field: "email",
            sort: "asc",
            width: 200,
          },

          {
            label: "Actions",
            field: "actions",
            width: 100,
          },
        ],

        rows: rows,
      }
      setcompanies(data)
    })
    
  }

  const toggleModal = () => {
    setshowModal(!showModal)
  }

  const submitRegistration = values => {
    const submitData = { ...values, client_id: user.id }
    setloading(true)
    console.log(submitData)

    generalService.createCompany(submitData).then(response => {
      console.log(response)
      if (response.status) {
        onSuccess()
        fetchCompanies()
      } else {
        onError("Error while processing application")
      }
    })
  }
  function onError(msg) {
    setloading(false)
    setregistrationError(msg)
  }

  function onSuccess() {
    setloading(false)
    setregistrationSuccess("Registration successful!")
    setTimeout(() => {
      setregistrationSuccess("")
    }, 8000)
    setregistrationError("")
    setshowModal(false)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Companies | REMA</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            {registrationSuccess ? (
              <Alert color="success">{registrationSuccess}</Alert>
            ) : null}
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Companies</h6>
              </Col>
              <Col md={4}>
                <div className="float-end">
                  <button
                    className="btn btn-primary btn-block"
                    onClick={() => {
                      setshowModal(true)
                    }}
                  >
                    <i className="fa fa-plus"></i> Add Company
                  </button>
                </div>
              </Col>
            </Row>
            <br></br>

            <Row>
              <MDBDataTable responsive striped bordered data={companies} />
            </Row>

            <CompanyModal
              open={showModal}
              toggleModal={toggleModal}
              loading={loading}
              submit={submitRegistration}
              error={registrationError}
            />
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Companies
